import {gsap, ScrollTrigger} from "../LibrariesImport";
import DevHelpers from "../utils/DevHelpers";

export default class BlockTextCards {
    static init() {
        this.blocks = document.querySelectorAll(".block-text-cards");

        if (this.blocks.length < 1) {
            return;
        }

        this.blocks.forEach(block => {
            this.reveal(block);
            this.pinTitle(block);
        });
    }

    static reveal(block) {
        const title = block.querySelector(".tc-title");
        const cards = block.querySelectorAll(".tc-cards li");
        const after = block.querySelector(".after");

        gsap.set(title.querySelector(".title-level-1"), { autoAlpha: 0 });

        gsap.set(after.querySelector(".rich-text"), { autoAlpha: 0, y: 50, willChange: "transform" });

        gsap.to(title.querySelector(".title-level-1"), {
            autoAlpha: 1,
            duration: 0.5,
            scrollTrigger: {
                trigger: title,
                start: "top 95%",
                end: "bottom 80%",
                scrub: true
            }
        });

        cards.forEach((card, index) => {
            gsap.set(card.querySelector(".tc-card-container"), { autoAlpha: 0, y: 50, willChange: "transform" });
            gsap.to(card.querySelector(".tc-card-container"), {
                autoAlpha: 1,
                x: 0,
                y: 0,
                duration: 0.5,
                scrollTrigger: {
                    trigger: card,
                    start: "top 95%",
                    end: "bottom 80%",
                    scrub: true
                }
            });
        });

        gsap.to(after.querySelector(".rich-text"), {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
                trigger: after,
                start: "top 95%",
                end: "bottom 80%",
                scrub: true
            }
        });
    }

    static pinTitle(block) {
        const title = block.querySelector(".tc-title");

        let mm = gsap.matchMedia();
        mm.add("(min-width: 768px)", () => {
            ScrollTrigger.create({
                trigger: block,
                pin: title,
                pinSpacing: false,
                start: "top "+parseInt(window.getComputedStyle(block).marginTop),
                end: () => "+=" + (block.offsetHeight - (parseInt(window.getComputedStyle(block).marginTop) * 2)),
            });
        });
    }
}